import React, { useRef, useState, useEffect } from 'react';
import { RightOutlined, CheckOutlined, ArrowRightOutlined, LeftCircleOutlined, RightCircleOutlined, LeftOutlined } from '@ant-design/icons';
import './index.scoped.scss';
import { useHistory } from 'react-router-dom';
// Dynamically loaded Swiper to reduce initial bundle size
import PartnersSection from '@@/components/PartnersSection';

import gou from '../../../assets/img/home/g-img.png';
import dian from '../../../assets/img/home/d-img.png';
import mainZy from '../../../assets/img/home/an-img.png';
import banner1 from '../../../assets/img/home/banner1.jpg';
import banner2 from '../../../assets/img/home/banner2.png';
import banner3 from '../../../assets/img/home/banner3.png';
import banner4 from '../../../assets/img/home/banner4.png';
import homeBannerIcon from '../../../assets/img/home/homeBannerIcon.png';

import ProductPonsultationFoot from '@@/components/ProductConsultation';
import { HttpService } from '@@/services/http.service';
// import FragmentBanner from './banner';
import './banner.css';
import Helmet from '@@/components/Helmet';

// 缓存 SwiperLib 以防止路由切换时重新加载导致闪烁
let cachedSwiperLib: any = null;

const Homepc = () => {
    const history = useHistory();

    const [newsList, setNewsList] = useState<any>([]);

    const [honorList, setHonorList] = useState<any>([
        {
            title: '数字中国建设峰会 | 金智塔科技首席科学家郑小林教授指出数据要素战略是应对大模型挑战的重要举措！',
            digest: '金智塔科技创始人兼首席科学家郑小林教授受邀出席“共建数据要素产业生态高峰论坛”，并作“隐私计算赋能数据要素合规流通”主旨演讲，共话数据要素市场培育与发展。',
            id: '150'
        },
        {
            title: '数博会载誉而归｜金智塔科技荣膺三大奖项',
            digest: '2023数博会由国家发展和改革委员会、工业和信息化部、国家互联网信息办公室和贵州省人民政府共同主办，作为数据要素合规流通与应用领军企业，金智塔科技荣膺“数博会”数据场景应用创新大赛三等奖、“2023数据交易十大优秀案例”奖及“2023数据安全流通创新案例”奖。',
            id: '153'
        },
        {
            title: '金智塔案例入选 IDC《 隐私计算最佳实践与探索》报告',
            digest: '近日，国际权威咨询机构IDC正式发布了《IDC PeerScape: 隐私计算最佳实践与探索》报告。“金智塔隐私计算安全融合政务数据赋能浙商银行智能风控”项目被作为最佳案例入选该报告，为更多用户构建技术架构、推动技术落地、实现业务升级提供参考。',
            id: '146'
        }
        // {
        //     title: '金智塔科技参与的又一国家重点研发计划项目启动',
        //     digest: '近日，由浙江大学牵头，浙江大学副校长、浙江大学长三角一体化发展研究中心主任黄先海教授任项目负责人，联合中国移动、浙江信产、同花顺、浙大滨江院、金智塔科技等9家行业头部单位共同实施的十四五国家重点研发计划“文化科技与现代服务业”重点专项“面向共同富裕的公共服务普惠供给技术及应用”项目启动暨实施方案咨询会顺利召开。金智塔科技CTO陈超超博士受邀出席',
        //     id: '143',
        // },
    ]);

    const [honorInfo, setHonorInfo] = useState<{ name: string; content: string }>({ name: '', content: '' });
    const [bannerList, setBannerList] = useState<any[]>([banner1, banner2, banner3, banner4]);
    const swiperRef = useRef<any>(null);

    const [bannerLoaded, setBannerLoaded] = useState(!!cachedSwiperLib);
    const [SwiperLib, setSwiperLib] = useState<any>(cachedSwiperLib);

    useEffect(() => {
        let isMounted = true;

        if (!cachedSwiperLib) {
            Promise.all([import('swiper'), import('swiper/react'), import('swiper/swiper-bundle.css')]).then(([SwiperCoreModule, SwiperReact]) => {
                if (isMounted) {
                    const SwiperCore = SwiperCoreModule.default;
                    const { Autoplay, Navigation, EffectCoverflow, Pagination } = SwiperCoreModule;
                    SwiperCore.use([Autoplay, Navigation, EffectCoverflow, Pagination]);
                    cachedSwiperLib = SwiperReact;
                    setSwiperLib(SwiperReact);
                }
            });
        }

        getHomeNews();
        // getIndexHonor();
        // getHonor();

        // setBannerDom();

        return () => {
            isMounted = false;
        };
    }, []);

    // 获取首页新闻列表
    const getHomeNews = async () => {
        // eslint-disable-next-line new-cap
        const [, res] = await HttpService('POST', '/news/getIndexNews', {});
        if (res) {
            setNewsList((res as any).newsList);
        }
    };

    // 获取首页荣誉列表
    const getIndexHonor = async () => {
        // eslint-disable-next-line new-cap
        const [, res] = await HttpService('POST', '/news/getIndexHonor', {});
        if (res) {
            setHonorList((res as any).newsList);
            // setNewsList(res.newsList);
        }
    };

    // 获取首页荣誉
    const getHonor = async () => {
        // eslint-disable-next-line new-cap
        const [, res] = await HttpService('POST', '/honor/getIndex', {});
        console.log('res.getIndexHonor:::', res);
        if (res) {
            setHonorInfo(res as any);
            // setNewsList(res.newsList);
        }
    };

    // 主要产品tab切换
    const [mainProductTabVal, setMainProductTabVal] = useState<number>(1);

    // 典型案例 轮播图的按钮下标
    const [exampleBoxBtn, setExampleBoxBtn] = useState<number>(1);
    const exampleSwiperRef = useRef<any>(null);

    const newsRemarkRef = useRef<any>(null);

    // 主要产品tab切换
    const mainProductTabValMouseMove = (val: number) => {
        console.log(val);
        setMainProductTabVal(val);
    };

    // 经典案例 按钮
    const exampleBtnhover = (val: number) => {
        if (val !== exampleBoxBtn) {
            setExampleBoxBtn(val - 1);
            if (exampleSwiperRef.current) {
                exampleSwiperRef.current.slideTo(val - 1);
            }
        }
    };

    // 典型案例 轮播图change事件
    const exampleSwiperChange = (val: any) => {
        setExampleBoxBtn(val.activeIndex + 1);
    };

    const newsRemarkLeftClick = () => {
        console.log('-----1');
        if (newsRemarkRef.current) {
            newsRemarkRef.current.slidePrev();
        }
    };
    const newsRemarkrightClick = () => {
        console.log('-----2');

        if (newsRemarkRef.current) {
            newsRemarkRef.current.slideNext();
        }
    };

    const goLink = (str: string, type: string) => {
        history.push({ pathname: str, search: type });
    };

    // 最新荣誉-查看详情
    const openNewsDetail = (id: any) => {
        history.push({ pathname: '/NewsDetail', search: id });
    };

    const mainProductDetail = (key: string) => {
        history.push({ pathname: '/mainProd', search: key });
    };

    return (
        <div className="flex f-fd-c fxy--center">
            {/* banner 开始 */}
            <Helmet />
            <div className="flex page-banner f-fd-c">
                <div className="relative page-switch">
                    {/* 轮播图未加载完成前的占位图 */}
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: 0,
                            opacity: bannerLoaded ? 0 : 1,
                            transition: bannerLoaded ? 'opacity 0.3s 0.3s' : 'none',
                            pointerEvents: 'none'
                        }}
                    >
                        {bannerList.length > 0 && <img className="switch-img" src={bannerList[0]} alt="placeholder" />}
                    </div>

                    <div style={{ position: 'relative', zIndex: 1, width: '100%', height: '100%', overflow: 'hidden', opacity: bannerLoaded ? 1 : 0, transition: 'opacity 0.3s' }}>
                        {SwiperLib && (
                            <SwiperLib.Swiper
                                onSwiper={(swiper: any) => {
                                    swiperRef.current = swiper;
                                    if (!bannerLoaded) {
                                        setTimeout(() => {
                                            setBannerLoaded(true);
                                        }, 100);
                                    }
                                }}
                                loop={true}
                                autoplay={{ delay: 3000, stopOnLastSlide: false, disableOnInteraction: true }}
                                pagination={{ clickable: true }}
                            >
                                {bannerList.map((item, index) => (
                                    <SwiperLib.SwiperSlide className="ta-c" key={index + ''}>
                                        <img className="switch-img" src={item} alt="" />
                                    </SwiperLib.SwiperSlide>
                                ))}
                            </SwiperLib.Swiper>
                        )}
                    </div>
                    {/* <div className="banner" id="banner2">
                        <div className="banner-view"></div>
                        <div className="banner-btn"></div>
                        <div className="banner-number" style={{ display: 'none' }}></div>
                        <div className="banner-progres"></div>
                    </div> */}

                    <div className="absolute banner-case2 fxy--center">
                        <div className="flex banner-case2-center">
                            <div className="flex flex-1">
                                <div className="flex banner-case2-box transition-hover-down cup f-fd-c f-jc-c" onClick={() => openNewsDetail('212')}>
                                    <div className="flex banner-case2-box-header f-ai-c">
                                        <img className="banner-case2-box-header-icon" src={homeBannerIcon} alt="" />
                                        <div className="banner-case2-box-header-txt">入选国际顶刊</div>
                                    </div>
                                    <div className="banner-case2-txt">树立大模型跨越协作典范</div>
                                </div>

                                <div className="flex banner-case2-box transition-hover-down cup f-fd-c f-jc-c" onClick={() => openNewsDetail('216')}>
                                    <div className="flex banner-case2-box-header f-ai-c">
                                        <img className="banner-case2-box-header-icon" src={homeBannerIcon} alt="" />
                                        <div className="banner-case2-box-header-txt">获评国际先进技术</div>
                                    </div>
                                    <div className="banner-case2-txt">省级科研项目通过成果鉴定</div>
                                </div>

                                <div className="flex banner-case2-box transition-hover-down cup f-fd-c f-jc-c" onClick={() => openNewsDetail('208')}>
                                    <div className="flex banner-case2-box-header f-ai-c">
                                        <img className="banner-case2-box-header-icon" src={homeBannerIcon} alt="" />
                                        <div className="banner-case2-box-header-txt">实现数据可信流通智能化</div>
                                    </div>
                                    <div className="banner-case2-txt">可信数据空间深度融合DeepSeek</div>
                                </div>

                                <div className="flex banner-case2-box transition-hover-down cup f-fd-c f-jc-c" onClick={() => openNewsDetail('218')}>
                                    <div className="flex banner-case2-box-header f-ai-c">
                                        <img className="banner-case2-box-header-icon" src={homeBannerIcon} alt="" />
                                        <div className="banner-case2-box-header-txt">喜获GraphRAG竞赛二等奖</div>
                                    </div>
                                    <div className="banner-case2-txt">AI能力获业界认可</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="banner-case1 fxy--center">
                <div className="flex banner-case1-center">
                    <div className="flex flex-1">
                        <div className="banner-case-card fxy--center f-fd-c cup" onClick={()=>openNewsDetail('158')}>
                            <div className="banner-case-card-header">全国一等奖</div>
                            <div className="banner-case-card-txt ta-c">中国信通院隐私计算大赛</div>
                        </div>
                        <div className="banner-case-card fxy--center f-fd-c cup" onClick={()=>mainProductDetail('2')}>
                            <div className="banner-case-card-header">重磅发布</div>
                            <div className="banner-case-card-txt ta-c">“智通”数据合规流通平台V1.0</div>
                        </div>
                        <div className="banner-case-card fxy--center f-fd-c cup" onClick={()=>openNewsDetail('143')}>
                            <div className="banner-case-card-header">攻坚关键技术</div>
                            <div className="banner-case-card-txt ta-c">承担国家重点研发项目启动</div>
                        </div>
                        <div className="banner-case-card fxy--center f-fd-c cup" onClick={()=>openNewsDetail('153')}>
                            <div className="banner-case-card-header">数博会载誉而归</div>
                            <div className="banner-case-card-txt ta-c">荣获三大奖项</div>
                        </div>
                    </div>
                </div>
            </div> */}

                {/* <div className='flex absolute banner-case'>

                <div className='flex banner-case-box f-jc-c f-ai-fe'>
                    <div className="flex f-fd-c f-jc-fe case-box1">
                        <div className='case-box1-title fxy--center'>星河杯</div>
                        <div className='case-box1-txt ta-c'>「 全国隐私计算大赛获得<br />一等奖 」</div>
                    </div>
                </div>
                {
                    honorList.map((item: any, index: number) =>

                        <div className="flex banner-case-box pa-s24 transition-hover-up f-jc-sb f-fd-c" key={index}>
                            <div className='case-box-header'>{item.title}</div>
                            <div className='case-box-content'>{item.digest}</div>
                            <div className='case-box-link' onClick={() => openNewsDetail((item.id).toString())}><span>查看详情</span><RightOutlined /></div>
                        </div>
                    )
                }
            </div> */}
            </div>
            {/* 主要产品 */}
            <div className="main-product fxy--center">
                <div className="product">
                    <div className="product-header fxy--center">主要产品</div>
                    <div className="product-content ta-c">坚持自主创新研发，以「技术+场景」双轮驱动产品升级与迭代，打造契合市场需求的数据合规流通与智能应用产品</div>
                    <div className="flex product-btn-list">
                        <div className={`relative product-btn  ${mainProductTabVal === 1 ? 'btn-active' : ''}`} onMouseMove={() => mainProductTabValMouseMove(1)}>
                            <div className={`absolute product-btn-txt ${mainProductTabVal === 1 ? 'wr' : ''}`}>智隐</div>
                            <img src={mainZy} className={`absolute product-btn-img ${mainProductTabVal === 1 ? 'opacity' : ''} `} alt="" />
                        </div>
                        <div className={`relative product-btn  ${mainProductTabVal === 2 ? 'btn-active' : ''}`} onMouseMove={() => mainProductTabValMouseMove(2)}>
                            <div className={`absolute product-btn-txt ${mainProductTabVal === 2 ? 'wr' : ''}`}>智通</div>
                            <img src={mainZy} className={`absolute product-btn-img ${mainProductTabVal === 2 ? 'opacity' : ''} `} alt="" />
                        </div>
                        <div className={`relative product-btn  ${mainProductTabVal === 3 ? 'btn-active' : ''}`} onMouseMove={() => mainProductTabValMouseMove(3)}>
                            <div className={`absolute product-btn-txt ${mainProductTabVal === 3 ? 'wr' : ''}`}>智信</div>
                            <img src={mainZy} className={`absolute product-btn-img ${mainProductTabVal === 3 ? 'opacity' : ''} `} alt="" />
                        </div>
                        <div className={`relative product-btn  ${mainProductTabVal === 4 ? 'btn-active' : ''}`} onMouseMove={() => mainProductTabValMouseMove(4)}>
                            {/* <div className='relative product-btn zx fxy--center' onMouseMove={() => mainProductTabValMouseMove(4)} onClick={() => mainProductTabValMouseMove(4)}> */}
                            <div className={`absolute product-btn-txt ${mainProductTabVal === 4 ? 'wr' : ''}`}>智学</div>
                            <img src={mainZy} className={`absolute product-btn-img ${mainProductTabVal === 4 ? 'opacity' : ''} `} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            {/* 主要产品-切换 */}
            <div className={`main-product-box fxy--center box-bg${mainProductTabVal}`}>
                <div className="product-box">
                    <div className="product-box-header">
                        <div className="flex product-box-header-title f-ai-c">
                            {mainProductTabVal === 1 && (
                                <>
                                    智隐 <img src={dian} className="product-box-header-title-dian" /> 隐私计算平台
                                </>
                            )}
                            {mainProductTabVal === 2 && (
                                <>
                                    智通 <img src={dian} className="product-box-header-title-dian" /> 数据合规流通平台
                                </>
                            )}
                            {mainProductTabVal === 3 && (
                                <>
                                    智信 <img src={dian} className="product-box-header-title-dian" /> 可信数据空间
                                </>
                            )}
                            {mainProductTabVal === 4 && (
                                <>
                                    智学 <img src={dian} className="product-box-header-title-dian" /> AI智能体平台
                                </>
                            )}
                        </div>
                        <div className="product-box-header-txt">
                            {mainProductTabVal === 1 && (
                                <>
                                    实现数据“可用不可见”、“用途可控可计量”，赋能数据要素安全高效流通，并促进数据要素的
                                    <br />
                                    融合创新应用。
                                </>
                            )}
                            {mainProductTabVal === 2 && (
                                <>
                                    提供数据合规融合加工、数据出域智能审查、数据产品安全交付、数据流通全程监管、国产信创生态支持等服务，
                                    <br />
                                    赋能数据产品市场化流通，加速可信人工智能发展。
                                </>
                            )}
                            {mainProductTabVal === 3 && (
                                <>
                                    提供数据资源融通、生态合作互认、数据产品加工与运营、空间安全监管及产品出域审查等数据合规流通全链路能力，
                                    <br />
                                    加速释放可信数据价值，助力行业高水平智能化发展。
                                </>
                            )}
                            {mainProductTabVal === 4 && (
                                <>
                                    提供行业咨询、即时对话、产品推荐、内容生成等深度洞察与精准推理服务，实现对复杂任务的高效管理和执行，
                                    <br />
                                    助力政府、零售、金融等行业用户提升决策质量与效率。
                                </>
                            )}
                        </div>
                    </div>
                    <div className="product-box-good">
                        <div className="product-box-good-title">产品优势</div>
                        <div className="flex good-list f-ai-c">
                            {mainProductTabVal === 1 && (
                                <>
                                    <div className="flex good-list-box">
                                        <div className="good-list-box-remark fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高安全</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高可用</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高性能</span>
                                        </div>
                                        <div className="good-list-box-remark fxy--center ml-s42">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高互联</span>
                                        </div>
                                        <div className="good-list-box-remark fxy--center ml-s42">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高扩展</span>
                                        </div>
                                    </div>
                                </>
                            )}

                            {mainProductTabVal === 2 && (
                                <>
                                    <div className="flex good-list-box">
                                        <div className="good-list-box-remark fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高安全</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高可用</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">强监管</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">灵活交付</span>
                                        </div>
                                    </div>
                                </>
                            )}

                            {mainProductTabVal === 3 && (
                                <>
                                    <div className="flex good-list-box">
                                        <div className="good-list-box-remark fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">数据安全与隐私保护</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高效跨域数据流通</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">全流程合规监管</span>
                                        </div>
                                    </div>
                                </>
                            )}

                            {mainProductTabVal === 4 && (
                                <>
                                    <div className="flex good-list-box">
                                        <div className="good-list-box-remark fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">多模态</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">高智能</span>
                                        </div>
                                        <div className="good-list-box-remark ml-s42 fxy--center">
                                            <img src={gou} className="good-list-box-remark-icon" />
                                            <span className="good-list-box-remark-txt">低成本</span>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    <div className="flex product-box-list">
                        {mainProductTabVal === 1 && (
                            <>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">联合建模</div>
                                    <div className="box-list-txt">支持多方数据在不出域的前提下完成模型训练，覆盖神经网络、决策树、逻辑回归等主流算法</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">联合统计</div>
                                    <div className="box-list-txt">支持多方数据在不出域的前提下完成统计，覆盖中位数、方差、偏离度等统计学指标</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">匿踪查询</div>
                                    <div className="box-list-txt">数据查询时，保护查询对象的身份信息不暴露给数源方，例如身份证号、电话号码、组织机构代码等</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">在线推理</div>
                                    <div className="box-list-txt">将训练完成的模型在隔离环境独立部署，支持千万级高并发、亿级大数据、毫米响应的场景需求</div>
                                </div>
                            </>
                        )}
                        {mainProductTabVal === 2 && (
                            <>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">数据产品合规加工</div>
                                    <div className="box-list-txt">提供大数据计算、隐私计算、安全沙箱等多种产品加工形式，全面满足用户不同业务场景需求</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">数据产品智能审查</div>
                                    <div className="box-list-txt">应用风险字段识别、文件动态封装、数据相似度匹配等关键技术，达到零信任安全标准</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">数据产品多态交易</div>
                                    <div className="box-list-txt">为公共数据和社会数据提供数据包、数据接口、数据报告、数据模型等多种交易形式</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">数据流通全程监管</div>
                                    <div className="box-list-txt">实现数据申请、数据导入、数据加工、产品交付、产品交易全流程监管，保障数据产品合规流通</div>
                                </div>
                            </>
                        )}
                        {mainProductTabVal === 3 && (
                            <>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">资源交互</div>
                                    <div className="box-list-txt">基于智能连接器，汇聚结构化、非结构化数源，支持分布式与集中式计算，实现 多资源方统一目录标识、统一身份登记、统一接口要求</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">价值共创</div>
                                    <div className="box-list-txt">
                                        满足非结构化数据处理、分布式安全计算、PB级数据计算等场景需求；提供接口、数据包、模型等产品形态，为生态各方提供数据产品供销一体服务
                                    </div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">可信管控</div>
                                    <div className="box-list-txt">提供用户身份安全、数据流转安全等全方位安全监管服务，并采用敏感数据识别等技术对产品进行严格出域审查</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">全链智能</div>
                                    <div className="box-list-txt">深度融合DeepSeek大模型能力，实现智能数源管理、智能分级分类、智能产 品加工、智能出域审查等数据可信流通全链路智能化落地</div>
                                </div>
                            </>
                        )}
                        {mainProductTabVal === 4 && (
                            <>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">行业知识注入</div>
                                    <div className="box-list-txt">通过多模态语料提取技术高效获取并深度整合行业专业知识，提升Agent在特定行业场景下的表现和决策精准度。</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">数智任务规划</div>
                                    <div className="box-list-txt">自动规划任务执行流程，实现资源的优化配置，大幅提升业务运营效率和决策响应速度。</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">知识图谱增强</div>
                                    <div className="box-list-txt">基于RAG和知识图谱技术将企业内外部信息进行系统化整理与关联，增强大模型推断能力与数据挖掘深度，为决策提供更加全面的支持。</div>
                                </div>
                                <div className="box-list transition-hover-up">
                                    <div className="box-list-title">场景化精准决策</div>
                                    <div className="box-list-txt">为用户提供个性化决策方案，助力其快速、精准做出业务判断，实现高效、稳健发展。</div>
                                </div>
                                {/* <div className="box-list transition-hover-up">
                                <div className="box-list-title">安全管理</div>
                                <div className="box-list-txt">利用对称和非对称密钥算法进行数据的全程加密；同时内置多种风控规则，多重防范原始数据泄露</div>
                            </div> */}
                            </>
                        )}
                    </div>

                    <div className="flex product-box-good-btn">
                        <div className="good-detail fxy--center" onClick={() => mainProductDetail(mainProductTabVal.toString())}>
                            查看详情
                        </div>
                    </div>
                </div>
            </div>
            {/* 典型案例 */}
            <div className="main-example fxy--center">
                <div className="main-example-box">
                    <div className="main-example-header fxy--center">典型案例</div>
                    <div className="text-center main-example-remark fxy--center">
                        联合浙江省数据局、北京市数据局、北京市数据集团、杭州市数据集团、宁波数字产业集团、湖州数字集团、杭州城投、人民数据、浙商银行、宁波银行、美的集团等行业标杆用户
                        <br />
                        打造100多个数据合规流通与智能应用典型案例
                    </div>
                    <div className="relative example-box">
                        {SwiperLib && (
                            <SwiperLib.Swiper
                                loop={false}
                                autoplay={true}
                                onSwiper={(swiper: any) => {
                                    exampleSwiperRef.current = swiper;
                                }}
                                onSlideChange={(swiper: any) => exampleSwiperChange(swiper)}
                            >
                                <SwiperLib.SwiperSlide>
                                    <div className="example-box1 box3-bg">
                                        <div className="example-box1-title">隐私计算合规融合数据助力银行智能风控与授信</div>
                                        <div className="example-box1-txt">
                                            金智塔科技联合多家银行，运用隐私计算技术对接了浙江省金融综合服务平台，安全融合政务数据，
                                            <br />
                                            助力银行智能风控等业务的创新发展
                                        </div>
                                        <div className="example-box1-btn fxy--center" onClick={() => goLink('/case', '1')}>
                                            查看详情
                                        </div>
                                    </div>
                                </SwiperLib.SwiperSlide>
                                <SwiperLib.SwiperSlide>
                                    <div className="example-box1 box1-bg">
                                        <div className="example-box1-title">隐私计算赋能政务数据合规多跨共享</div>
                                        <div className="example-box1-txt">
                                            金智塔科技联合某省统计局、经信厅等单位，应用隐私计算等技术，构建了省市县三级一体化横向、
                                            <br />
                                            纵向的数据要素流通体系。
                                        </div>
                                        <div className="example-box1-btn fxy--center" onClick={() => goLink('/case', '2')}>
                                            查看详情
                                        </div>
                                    </div>
                                </SwiperLib.SwiperSlide>
                                <SwiperLib.SwiperSlide>
                                    <div className="example-box1 box2-bg">
                                        <div className="example-box1-title">某副省级城市数据要素流通平台建设</div>
                                        <div className="example-box1-txt">
                                            金智塔科技应用隐私计算、可信环境计算等技术，为某副省级城市构建了一个安全、合规、可信、
                                            <br />
                                            高效的数据加工和交付审查环境。
                                        </div>
                                        <div className="example-box1-btn fxy--center" onClick={() => goLink('/case', '3')}>
                                            查看详情
                                        </div>
                                    </div>
                                </SwiperLib.SwiperSlide>
                                <SwiperLib.SwiperSlide>
                                    <div className="example-box1 box4-bg">
                                        <div className="example-box1-title">家电行业数据空间创新产业金融服务</div>
                                        <div className="example-box1-txt">
                                            打破企业间的数据壁垒，推动家电供应链金融及产业链分析等应用，
                                            <br />
                                            有效促进金融服务的智能化与精准化。
                                        </div>
                                        <div className="example-box1-btn fxy--center" onClick={() => goLink('/case', '4')}>
                                            查看详情
                                        </div>
                                    </div>
                                </SwiperLib.SwiperSlide>
                                <SwiperLib.SwiperSlide>
                                    <div className="example-box1 box5-bg">
                                        <div className="example-box1-title">基于大模型的金融智能营销</div>
                                        <div className="example-box1-txt">
                                            构建客户、客群、产品及工具四大知识库引擎，打造端到端智能营销体系，
                                            <br />
                                            全面提升营销转化率与客户满意度。
                                        </div>
                                        <div className="example-box1-btn fxy--center" onClick={() => goLink('/case', '5')}>
                                            查看详情
                                        </div>
                                    </div>
                                </SwiperLib.SwiperSlide>
                            </SwiperLib.Swiper>
                        )}

                        {/* 按钮组 */}
                        <div className="flex absolute example-box-btn-list f-ai-fe">
                            <div className={`example-box-btn cup ${exampleBoxBtn === 1 ? 'example-box-btn-hover' : ''}`} onMouseMove={() => exampleBtnhover(1)}>
                                <div className="example-box-btn-txt">
                                    隐私计算合规融合数据助力
                                    <br />
                                    银行智能风控与授信
                                </div>
                                <div className="example-box-btn-icon"></div>
                            </div>
                            <div className={`example-box-btn cup ${exampleBoxBtn === 2 ? 'example-box-btn-hover' : ''}`} onMouseMove={() => exampleBtnhover(2)}>
                                <div className="example-box-btn-txt">
                                    隐私计算赋能政务数据
                                    <br />
                                    合规多跨共享
                                </div>
                                <div className="example-box-btn-icon"></div>
                            </div>
                            <div className={`example-box-btn cup ${exampleBoxBtn === 3 ? 'example-box-btn-hover' : ''}`} onMouseMove={() => exampleBtnhover(3)}>
                                <div className="example-box-btn-txt">
                                    某副省级城市数据要素
                                    <br />
                                    流通平台建设
                                </div>
                                <div className="example-box-btn-icon"></div>
                            </div>
                            <div className={`example-box-btn cup ${exampleBoxBtn === 4 ? 'example-box-btn-hover' : ''}`} onMouseMove={() => exampleBtnhover(4)}>
                                <div className="example-box-btn-txt">
                                    家电行业数据空间创新
                                    <br />
                                    产业金融服务
                                </div>
                                <div className="example-box-btn-icon"></div>
                            </div>
                            <div className={`example-box-btn cup ${exampleBoxBtn === 5 ? 'example-box-btn-hover' : ''}`} onMouseMove={() => exampleBtnhover(5)}>
                                <div className="example-box-btn-txt">
                                    基于大模型的
                                    <br />
                                    金融智能营销
                                </div>
                                <div className="example-box-btn-icon"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* 新闻资讯 */}
            <div className="news-remark fxy--center">
                <div className="news-remark-box">
                    <div className="news-remark-title fxy--center">新闻资讯</div>
                    <div className="news-remark-txt fxy--center">
                        您的关注与支持，是我们不断向前的动力{' '}
                        <a className="ml-s10" onClick={() => goLink('/NewsPage', '')}>
                            查看全部新闻 <ArrowRightOutlined />
                        </a>
                    </div>
                    <div className="relative news-remark-swiper">
                        {SwiperLib && (
                            <SwiperLib.Swiper
                                loop={true}
                                autoplay={true}
                                slidesPerView={3}
                                onSwiper={(swiper: any) => {
                                    newsRemarkRef.current = swiper;
                                }}
                            >
                                {newsList.map((item: any, index: number) => (
                                    <SwiperLib.SwiperSlide key={index}>
                                        <div key={index} className="flex news-remark-swiper-box f-fd-c cup" onClick={() => goLink('/NewsDetail', item.id.toString())}>
                                            <img className="new-remark-img" src={item.coverImg} />
                                            <div className="flex-1 new-remark-box-bg">
                                                <div className="new-remark-box-bg-date fx--between-center">
                                                    <span>{item.createTime}</span>
                                                    <ArrowRightOutlined />
                                                </div>
                                                <div className="new-remark-box-bg-title">{item.title}</div>
                                                <div className="new-remark-box-bg-content">{item.digest}</div>
                                            </div>
                                        </div>
                                    </SwiperLib.SwiperSlide>
                                ))}
                            </SwiperLib.Swiper>
                        )}
                        <div className="news-remark-left cup" onClick={newsRemarkLeftClick}>
                            <LeftCircleOutlined />
                        </div>
                        <div className="news-remark-right cup" onClick={newsRemarkrightClick}>
                            <RightCircleOutlined />
                        </div>
                    </div>
                </div>
            </div>
            {/* 生态伙伴 */}
            <div className="ecological-partner fxy--center">
                <div className="ecological-partner-main">
                    <div className="ecological-partner-title fxy--center">生态伙伴</div>
                    <div className="ecological-partner-txt fxy--center">深度融合产学研用资源，共同构建数据要素合规流通与应用生态</div>
                    <PartnersSection />
                    {/* <div className="relative ecological-partner-box">
                        <img className="absolute ecological-partner-box-img" src={sthzhbImg1} />
                        <img className="absolute ecological-partner-box-yuan" src={sthzhbImg2} />
                        <img className="absolute ecological-partner-box-qiu" src={sthzhbImg3} />
                    </div> */}
                </div>
            </div>
            {/* 赋能 */}
            <ProductPonsultationFoot />
        </div>
    );
};

export default Homepc;
